module.exports = __webpack_public_path__ + "img/tmf2026_first.0e73cc94.jpg";